import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import {
  Form,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Input,
  Button,
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { Dialog } from "primereact/dialog"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
// import HelpMenu from "../CommonForBoth/TopbarDropdown/HelpMenu";
import NotificationDropdown3 from "../CommonForBoth/TopbarDropdown/NotificationDropdown3"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import AtsImg from "../../assets/images/ats-logo2.png"
import USATS from "../../assets/images/USATS2.png"
import { withTranslation } from "react-i18next"
import AddMenu from "../CommonForBoth/TopbarDropdown/AddMenu"
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import axios from "axios"
import { BsChatLeftText } from "react-icons/bs"
import { FaBell } from "react-icons/fa"
import Modal from "react-bootstrap/Modal"
import { onMessage } from "firebase/messaging"
import { getDeviceTokenView, messaging } from "components/Common/FirebaseConfig"
import { Howl } from "howler";
import notify from "../../assets/images/mixkit-correct-answer-tone-2870.wav";
import Swal from "sweetalert2"

const getStoredUserInfo = () => {
  try {
    return JSON.parse(sessionStorage.getItem("user-info") || "{}")
  } catch {
    return {}
  }
}

const getDocumentAlertCompany = () => {
  const userInfo = getStoredUserInfo()
  const companies = userInfo?.user_details?.companies_data || []
  const activeId = sessionStorage.getItem("active-company-id")
  return companies.find(company => String(company.company_id) === String(activeId)) || companies[0] || null
}

const getConcreteCompanyId = company => {
  const companyId = company?.company_id ?? company?.id
  return companyId && String(companyId).toLowerCase() !== "all" ? companyId : null
}

const normaliseDocumentStatus = value => String(value || "").trim().toLowerCase()
const isUploadedDocument = value => {
  const status = normaliseDocumentStatus(value)
  if (!status || status.includes("not uploaded") || status.includes("not_uploaded")) return false
  return /\b(uploaded|verified|approved)\b/.test(status)
}
const getSessionBearer = () => {
  const userInfo = getStoredUserInfo()
  const token = userInfo?.token || userInfo?.access_token || sessionStorage.getItem("token") || ""
  if (!token) return ""
  return String(token).toLowerCase().startsWith("bearer ") ? String(token) : `Bearer ${token}`
}

const Header = props => {
  const navigate = useNavigate()
   const notificationSoundRef = useRef(null);
  const notificationFetchInFlightRef = useRef(false);

  if (!notificationSoundRef.current) {
    notificationSoundRef.current = new Howl({
      src: [notify],
      volume: 1,
    });
  }
  useEffect(() => {
  const playOnLoad = async () => {
    try {
      notificationSoundRef.current.play();
    } catch (err) {
      console.log("Autoplay blocked by browser");
    }
  };

  playOnLoad();
}, []);

  const [advansearch, setAdvansearch] = useState(false)
  const [popAdvance, setPopAdvance] = useState(null)
  const userInfos = JSON.parse(sessionStorage.getItem("user-info"))
  const searchpopup = [
    { name: "Resumes", code: "resume" },
    { name: "Job Titles", code: "job" },
    { name: "Primary Skills", code: "primary_skills" },
    { name: "Secondary Skills", code: "secondary_skills" },
    { name: "Notes", code: "notes" },
  ]
  const [showModal, setShowModal] = useState(false)
  const [activeTab, setActiveTab] = useState("all");
  const formatUTCDate = (dateStr) => {
  if (!dateStr) return "-";

  let clean = dateStr;

  // Handle ISO format (with T and Z)
  if (clean.includes("T")) {
    clean = clean.split(".")[0].replace("T", " ").replace("Z", "");
  }

  const [date, time] = clean.split(" ");
  if (!date || !time) return dateStr;

  const [year, month, day] = date.split("-");
  const [hour, minute] = time.split(":");

  // 👇 AM/PM logic
  const hourNum = Number(hour);
  const ampm = hourNum >= 12 ? "PM" : "AM";

  return `${day}/${month}/${year}, ${hour}:${minute} ${ampm}`;
};

const handleMarkAsRead = async (notificationId) => {
  const result = await Swal.fire({
    title: "Mark as read?",
    text: "This notification will be marked as read.",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  // ✅ Optimistic UI update
  setAllNotificationData(prev =>
    prev.map(n =>
      n.id === notificationId ? { ...n, is_read: true } : n
    )
  );

  try {
    await markSingleAsRead(notificationId);

    Swal.fire({
      icon: "success",
      title: "Marked as read",
      timer: 1000,
      showConfirmButton: false,
    });
  } catch (err) {
    // rollback if API fails
    setAllNotificationData(prev =>
      prev.map(n =>
        n.id === notificationId ? { ...n, is_read: false } : n
      )
    );
  }
};


const handleMarkAllAsRead = async () => {
  if (unreadCount === 0) return;
  const result = await Swal.fire({
    title: "Mark all as read?",
    text: "All unread notifications will be marked as read.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, mark all",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  // ✅ Optimistic update
  setAllNotificationData(prev =>
    prev.map(n => ({ ...n, is_read: true }))
  );

  try {
    await markAllAsRead();

    Swal.fire({
      icon: "success",
      title: "All notifications marked as read",
      timer: 1200,
      showConfirmButton: false,
    });
  } catch (err) {
    console.log(err)
    // optional rollback
    getAllNotifications();
  }
};



  const handleNotificationShow = () => {
    // notificationSoundRef.current.play();
    setShowModal(true)
  }

  // const markAsRead = (id) => {
  //   setNotifications(notifications.map(notification =>
  //     notification.id === id ? { ...notification, isRead: true } : notification
  //   ));
  // };

  const [fields, setFields] = useState([])
  const dropdownOptions = [
    { label: "City", value: "city" },
    { label: "Company", value: "company" },
    { label: "Primary Skill", value: "primary skill" },
    { label: "Postal Code", value: "postal code" },
    { label: "Job Title", value: "job title" },
  ]
  const [notificationData, setNotificationData] = useState([])
// const [notificationTrigger, setNotificationTrigger] = useState(0);
// useEffect(() => {
//   getDeviceTokenView();
//   const unsubscribe = onMessage(messaging, (payload) => {
//     console.log("Firebase message received:", payload); 
//     getAllNotifications(); 
//     setNotificationTrigger(prev => prev + 1); 
//   });
//   return () => unsubscribe(); 
// }, [notificationTrigger]); 
  // useEffect(() => {
  //   getDeviceTokenView()
  //   onMessage(messaging, payload => {
  //     // setOnMessage1(payload)
  //     getAllNotifications()
  //   })
  // }, [])
  const empCode = userInfos?.user_details?.employee_code
  const [allNotificationPopup, setAllNotificationPopup] = useState(false)
  const [allNotificationData, setAllNotificationData] = useState([])
  const [tabLoading, setTabLoading] = useState(false);

 const filteredNotifications = allNotificationData.filter(n => {
  if (activeTab === "unread") return !n.is_read;
  if (activeTab === "read") return n.is_read;
  return true;
});

  const [readNotificationCount, setReadNotificationCount] = useState(0)
  const [readNotificationCount1, setReadNotificationCount1] = useState(0)
  const [prevNotificationCount, setPrevNotificationCount] = useState(0)
  const [documentAlertCompany, setDocumentAlertCompany] = useState(getDocumentAlertCompany)
  const [documentAlerts, setDocumentAlerts] = useState([])
  const [documentAlertOpen, setDocumentAlertOpen] = useState(false)
  const [documentAlertLoading, setDocumentAlertLoading] = useState(false)
  const [documentAlertError, setDocumentAlertError] = useState("")
  // const notificationSound = new Howl({
  //     src: [notify],
  //     volume: 1,
  // });

  // const playNotificationSound = () => {
  //     notificationSound.play();
  // };
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const companies = userInfos?.user_details?.companies_data || [];
    const hasVgus = companies.some(
      (c) => c.company_domain === "vgus"
    );
    const logo = hasVgus ? USATS : AtsImg;

  const getDocumentAlertData = async (company = documentAlertCompany) => {
    const selectedCompanyId = getConcreteCompanyId(company)
    if (!selectedCompanyId) {
      setDocumentAlerts([])
      return
    }
    setDocumentAlertLoading(true)
    setDocumentAlertError("")
    setDocumentAlerts([])
    try {
      const response = await axios.get(
        "/api/v1/tracker-report/",
        {
          params: {
            company_id: selectedCompanyId,
            recruiter_id: getStoredUserInfo()?.user_details?.user_id || getStoredUserInfo()?.id,
            include_candidate_details: true,
            page: 1,
            size: 100,
          },
          headers: getSessionBearer() ? { Authorization: getSessionBearer() } : undefined,
        }
      )
      const payload = response.data || {}
      const reportRows = Array.isArray(payload?.results?.data)
        ? payload.results.data
        : Array.isArray(payload?.results)
          ? payload.results
          : Array.isArray(payload?.data?.results)
            ? payload.data.results
            : []
      const directCandidates = payload?.documentation_details?.candidates || payload?.data?.documentation_details?.candidates
      const documentationCandidates = Array.isArray(directCandidates)
        ? directCandidates
        : reportRows.flatMap(row => Array.isArray(row?.documentation_details?.candidates)
          ? row.documentation_details.candidates
          : [])
      const candidateDetails = reportRows.flatMap(row => Array.isArray(row?.candidate_details) ? row.candidate_details : [])
      const candidateMap = new Map()
      documentationCandidates.forEach(candidate => {
        const key = candidate.jobCandidateId || candidate.job_candidate_id || candidate.candidate_id || candidate.id
        candidateMap.set(key || `document-${candidateMap.size}`, candidate)
      })
      candidateDetails.forEach(candidate => {
        const key = candidate.jobCandidateId || candidate.job_candidate_id || candidate.candidate_id || candidate.id
        const existing = candidateMap.get(key)
        candidateMap.set(key || `candidate-${candidateMap.size}`, { ...existing, ...candidate })
      })
      const candidates = [...candidateMap.values()]
      const pendingCandidates = candidates.filter(candidate => {
        const statuses = [
          candidate.offerLetterStatus,
          candidate.offer_letter_status,
          candidate.joiningStatus,
          candidate.joining_status,
          candidate.status,
          candidate.candidateStatus,
        ].map(normaliseDocumentStatus)
        const excluded = statuses.some(status =>
          ["archived", "deleted", "rejected", "joined"].some(value => status.includes(value))
        )
        const tasks = candidate.document_collection_tasks || candidate.documentCollectionTasks
        return !excluded && Array.isArray(tasks) && tasks.some(task =>
          Number(task.totalPendingDocuments || 0) > 0
        )
      }).map(candidate => {
        const tasks = Array.isArray(candidate.document_collection_tasks)
          ? candidate.document_collection_tasks
          : Array.isArray(candidate.documentCollectionTasks) ? candidate.documentCollectionTasks : []
        const documents = tasks.flatMap(task => Array.isArray(task.documents) ? task.documents : [])
        const checklist = tasks.flatMap(task => {
          const items = task.checklist || task.checklistItems || task.checkList || []
          return Array.isArray(items) ? items : []
        })
        const getDocumentName = item => item.documentType || item.document_type || item.name || item.documentName
        const getDocumentId = item => {
          const rawId = item?.id ?? item?.documentTypeId ?? item?.document_type_id ?? getDocumentName(item)
          return rawId === null || rawId === undefined || rawId === "" ? "" : String(rawId)
        }
        const requiredDocuments = [...new Map(checklist.map(item => {
          const document = typeof item === "string" ? { id: item, name: item } : item
          const id = getDocumentId(document)
          return [id, {
            id,
            name: document.name || document.itemName || document.checklistName || document.documentType || "Unnamed document",
          }]
        }).filter(([id]) => id)).values()]
        const uploadedDocuments = [...new Map(documents
          .filter(item => isUploadedDocument(item.uploadStatus || item.upload_status))
          .map(item => {
            const id = getDocumentId(item)
            return [id, { id, name: getDocumentName(item) || "Unnamed document" }]
          })
          .filter(([id]) => id)).values()]
        const uploadedDocumentIds = new Set(uploadedDocuments.map(document => document.id))
        const missingDocuments = requiredDocuments.filter(document => !uploadedDocumentIds.has(document.id))
        const uploadedNames = uploadedDocuments.map(document => document.name).filter(Boolean)
        const resolvedMissingNames = missingDocuments.map(document => document.name).filter(Boolean)
        const pendingCount = missingDocuments.length
        const requiredCount = requiredDocuments.length
        const uploadedCount = uploadedDocuments.length
        const uploadedAt = documents.map(item => item.uploadedAt).filter(Boolean).sort().pop() || null
        const dueDetails = documents
          .filter(item => item.dueDate || item.overdueDays)
          .map(item => ({
            name: item.documentType || item.name || "Document",
            dueDate: item.dueDate || "-",
            overdueDays: Number(item.overdueDays || 0),
          }))
        return {
          ...candidate,
          jobTitle: candidate.jobTitle || candidate.job_title || candidate.job?.job_title || "-",
          employeeName: candidate.employeeName || candidate.hrms_employee_name || candidate.candidate_name || candidate.name || "Unnamed candidate",
          personalEmail: candidate.personalEmail || candidate.hrms_email || candidate.email || "",
          jobCandidateId: candidate.jobCandidateId || candidate.job_candidate_id || candidate.id,
          missingNames: resolvedMissingNames.length
            ? resolvedMissingNames
            : pendingCount > 0 ? [`${pendingCount} pending document${pendingCount === 1 ? "" : "s"}`] : [],
          uploadedNames,
          requiredCount,
          uploadedCount,
          pendingCount,
          dueDetails,
          uploadedAt,
        }
      })
      setDocumentAlerts(pendingCandidates)
    } catch (error) {
      console.error("Fetch document alerts failed", error)
      setDocumentAlerts([])
      setDocumentAlertError("Unable to load document status")
    } finally {
      setDocumentAlertLoading(false)
    }
  }

  useEffect(() => {
    const handleCompanyChanged = event => {
      const eventCompany = event.detail?.company
      const company = getConcreteCompanyId(eventCompany)
        ? eventCompany
        : getDocumentAlertCompany()
      setDocumentAlertCompany(company)
      setDocumentAlerts([])
      setDocumentAlertOpen(false)
    }
    const handleDocumentAlertRefresh = () => getDocumentAlertData(getDocumentAlertCompany())
    window.addEventListener("ats-company-changed", handleCompanyChanged)
    window.addEventListener("ats-document-alert-refresh", handleDocumentAlertRefresh)
    const refreshTimer = window.setInterval(() => getDocumentAlertData(getDocumentAlertCompany()), 60000)
    return () => {
      window.removeEventListener("ats-company-changed", handleCompanyChanged)
      window.removeEventListener("ats-document-alert-refresh", handleDocumentAlertRefresh)
      window.clearInterval(refreshTimer)
    }
  }, [])

  useEffect(() => {
    getDocumentAlertData(documentAlertCompany)
  }, [documentAlertCompany?.company_id])

  const openDocumentAlerts = () => {
    setDocumentAlertOpen(previous => !previous)
    getDocumentAlertData(documentAlertCompany)
  }
  // const getAllNotifications = async seeall => {
  //   try {
  //     const response = await axios.get("/api/v1/view-all-notifications/", {
  //       params: {
  //         emp_code: empCode,
  //         company_id: intialcompanyId,
  //       },
  //     })

  //     // Extract notifications from the API response
  //     const notifications = response.data.result[0].notifications || []

  //     console.log("notifications.length2222",notifications.length)

  //     // Update state
  //     setAllNotificationData(notifications)

  //     // Calculate unread count
  //     const unreadCount = notifications.filter(
  //       notification => !notification.is_read
  //     ).length

  //     // Update notification count
  //     const displayCount = unreadCount > 10 ? "10+" : unreadCount
  //     setReadNotificationCount(unreadCount)
  //     setReadNotificationCount1(unreadCount)

  //     // Optional: Log the response for debugging
  //     console.log("called")
  //     console.log("Fetched notifications:", notifications)
  //   } catch (error) {
  //     console.error("Error fetching notifications:", error)
  //     setAllNotificationData([]);
  //   }
  // }
//   useEffect(() => {
//   getAllNotifications();

//   const interval = setInterval(() => {
//     getAllNotifications();
//   }, 10000);

//   return () => clearInterval(interval);
// }, []);
const getAllNotifications = async () => {
  if (notificationFetchInFlightRef.current) return;

  notificationFetchInFlightRef.current = true;
  try {
    setTabLoading(true);
    const params = {
      emp_code: empCode,
      company_id: intialcompanyId,
    };

    const res = await axios.get(
      "/api/v1/view-all-notifications/",
      { params }
    );

    const list = Array.isArray(res.data?.result?.[0]?.notifications)
  ? res.data.result[0].notifications
  : [];


    setAllNotificationData(list);

    // unread count for bell
    const unread = list.filter(n => !n.is_read).length;
    setReadNotificationCount(unread);
  } catch (error) {
    console.error("Fetch notifications failed", error);
    setAllNotificationData([]);
  }
  finally {
    notificationFetchInFlightRef.current = false;
    setTabLoading(false);
  }
};

useEffect(() => {
  getAllNotifications();
}, []);

useEffect(() => {
  try {
    getDeviceTokenView();
  } catch (err) {
    console.warn("getDeviceTokenView failed:", err);
  }

  let unsubscribe = null;

  try {
    unsubscribe = onMessage(messaging, payload => {
      console.log("Firebase foreground message received:", payload);

      try {
        notificationSoundRef.current?.play();
      } catch (err) {
        console.warn("Failed to play notification sound", err);
      }

      getAllNotifications();
    });
  } catch (err) {
    console.warn("onMessage registration failed:", err);
  }

  return () => {
    if (typeof unsubscribe === "function") {
      unsubscribe();
    }
  };
}, []);

const markAllAsRead = async () => {
  try {
    await axios.post(
      "/api/v1/mark-all-read/",
      {
        emp_code: empCode,
        company_id: intialcompanyId,
      },
    );

    // optimistic UI update
    setAllNotificationData(prev =>
      prev.map(n => ({ ...n, is_read: true }))
    );

    setReadNotificationCount(0);
  } catch (error) {
    console.error("Mark all as read failed", error);
  }
};

const allCount = allNotificationData.length;
const unreadCount = allNotificationData.filter(n => !n.is_read).length;
const readCount = allNotificationData.filter(n => n.is_read).length;

// Register Firebase foreground message handler to update notifications in real-time
// useEffect(() => {
//   // request/refresh device token for this client
//   try {
//     getDeviceTokenView();
//   } catch (err) {
//     console.warn("getDeviceTokenView failed:", err);
//   }

//   // Subscribe to foreground messages
//   try {
//     const unsub = onMessage(messaging, payload => {
//       console.log("Firebase foreground message received:", payload);
//       try {
//         if (notificationSoundRef?.current) notificationSoundRef.current.play();
//       } catch (err) {
//         console.warn("Failed to play notification sound", err);
//       }
//       getAllNotifications();
//     });

//     return () => {
//       try {
//         if (typeof unsub === "function") unsub();
//       } catch (err) {
//         console.warn("Failed to unsubscribe onMessage", err);
//       }
//     };
//   } catch (err) {
//     console.warn("onMessage registration failed:", err);
//   }
// }, []);






  // onMessage(messaging, payload => {
  //   getAllNotifications()
  // })
//   useEffect(() => {
//   const handleNotificationUpdate = () => {
//     getAllNotifications();
//   };
//   window.addEventListener('notificationUpdated', handleNotificationUpdate);
//   return () => {
//     window.removeEventListener('notificationUpdated', handleNotificationUpdate);
//   };
// }, []);

  // const markAsRead = async (isMarkAllRead, rtn_id, index) => {
  //   // const headers = ApiHeaders(multitenant)
  //   try {
  //     const requestBody = {}
  //     if (isMarkAllRead) {
  //       requestBody.mark_all_read = "ok"
  //       requestBody.emp_code =
  //         userinfo?.data?.employee?.workDetails_EmployeeNumber
  //     } else {
  //       requestBody.rtn_id = rtn_id
  //     }
  //     const response = await axios.patch(
  //       "/api/alerts/view-all-notifications/",
  //       requestBody
  //     )
  //     getAllNotifications()
  //     const updatedNotificationData = [...notificationData]
  //     updatedNotificationData[index].data.read = true
  //     setNotificationData(updatedNotificationData)
  //     localStorage.setItem(
  //       "notifications",
  //       JSON.stringify(updatedNotificationData)
  //     )
  //   } catch (error) {
  //     console.error("Failed to mark notification as read:", error)
  //   }
  // }
  // useEffect(() => {
  //   if (readNotificationCount1 > prevNotificationCount) {
  //     playNotificationSound()
  //   }

  //   setPrevNotificationCount(readNotificationCount1)
  // }, [readNotificationCount1])

  // onMessage(messaging, payload => {
  //   getAllNotifications()
  // })
  const handleAddField = () => {
    setFields([...fields, { id: Date.now(), value: null }])
  }

  const handleFieldChange = (id, value) => {
    setFields(
      fields.map(field => (field.id === id ? { ...field, value } : field))
    )
  }

  const handleRemoveField = id => {
    setFields(fields.filter(field => field.id !== id))
  }

  const [menu, setMenu] = useState(false)
  const [candidateOption, setCandidateOption] = useState("Select Option")
  const [dropdown1Open, setDropdown1Open] = useState(false)
  const [toggleChange, setToggleChange] = useState(false)

  const handleCandidateSelect = option => setCandidateOption(option)

  const [formValues, setFormValues] = useState({
    from: "",
    to: "",
    subject: "",
    hasWords: "",
    doesntHave: "",
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }

  const handleSubmit = e => {
    e.preventDefault()
  }

  const [search, setSearch] = useState(false)
  const [singlebtn, setSinglebtn] = useState(false)
  const [inputContains, setInputContains] = useState("")
  const [excludedSearch, setExcludedSearch] = useState("")
  const [exactSearch, setExactSearch] = useState("")

  const [errors, setErrors] = useState({})

  const validateForm = () => {
    const newErrors = {}
    if (!popAdvance) newErrors.popAdvance = "Please select a search category"
    if (!inputContains?.trim())
      newErrors.inputContains = "Contains field is required"
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleInputContains = e => {
    setInputContains(e.target.value)
    if (e.target.value?.trim()) {
      setErrors(prev => ({ ...prev, inputContains: "" }))
    }
  }

  const handleResetAdvancepop = () => {
    setPopAdvance(null)
    setInputContains("")
    setExcludedSearch("")
    setExactSearch("")
    setFields([])
    setErrors({})
  }

  const handleSearchSelect = e => {
    e.preventDefault()
    if (validateForm()) {
      navigate("/search-results", {
        state: {
          searchType: popAdvance.code,
          inputContains,
          exactSearch,
          excludedSearch, // Include excludedSearch in the state
        },
      })
      setAdvansearch(false)
      handleResetAdvancepop()
    }
  }

  const handlePopAdvanceChange = e => {
    setPopAdvance(e.value)
    if (e.value) {
      setErrors(prev => ({ ...prev, popAdvance: "" }))
    }
  }

  const closeModal = () => {
    setAdvansearch(false)
    handleResetAdvancepop()
  }

  const toggleFullscreen = () => {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  const tToggle = () => {
    setToggleChange(!toggleChange)
    const body = document.body
    if (window.screen.width <= 992) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  useEffect(() => {
    localStorage.setItem(toggleChange ? "true" : "false", "footerClass")
  }, [toggleChange])
  const [profileData, setProfileData] = useState(null)
  useEffect(() => {
    const fetchmyaccount = async () => {
      var userInfo = JSON.parse(sessionStorage.getItem("user-info"))
      try {
        const response = await axios.get(
          `/api/v1/users/${userInfo.user_details.user_id}/`
        )
        console.log("response", response)
        setProfileData(response.data)
      } catch (error) {
        console.error("Error fetching user data", error)
      }
    }

    fetchmyaccount()
  }, [])
const markSingleAsRead = async (notificationId, index) => {
  try {
    await axios.post(
      "/api/v1/mark-read/",
      { notification_id: notificationId }
    );

    // setAllNotificationData(prev =>
    //   prev.map((item, i) =>
    //     i === index ? { ...item, is_read: true } : item
    //   )
    // );

    // setReadNotificationCount(prev => Math.max(prev - 1, 0));
  } catch (error) {
    console.error("Mark single notification failed", error);
  }
};



  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-sm px-4 font-size-24 header-item"
              id="vertical-menu-btn"
              onClick={tToggle}
              data-target="#topnav-menu-content"
            >
              <i className="pi pi-bars fs-6"></i>
            </button>

            <div className="navbar-brand-box">
              <Link to="/ats-dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src="https://varundigital.bharatpayroll.com/static/media/hrms-logo6.1a823c0d278b5300afda.png" />
                  <h4> ATS </h4>
                </span>
                <span className="logo-lg">
                  <h4> ATS </h4>
                </span>
              </Link>
              <Link to="/ats-dashboard" className="logo logo-light">
                <span className="logo-sm favicon-logo">
                  <img src={logo} alt="" width="140px" />
                </span>
                <span className="logo-lg barath-logo">
                  <img src={logo} alt="" width="140px" />
                </span>
              </Link>
            </div>

            <div className="app-search d-none d-lg-block">
              <div
                className="position-relative d-flex align-items-center"
                style={{ backgroundColor: "#eaf1fb", borderRadius: "30px" }}
              >
                <div className="input-wrapper" style={{ position: "relative" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={props.t("Advanced Search") + "..."}
                    style={{
                      paddingRight: "40px",
                      width: "600px",
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "15px",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "14px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <i
                      className="pi pi-sliders-h"
                      onClick={() => setAdvansearch(true)}
                      tooltip="Profile"
                      tooltipOptions={{ position: "bottom" }}
                    ></i>
                  </span>
                </div>

                <div className="card flex justify-content-center headpop-main">
                  <Dialog
                    className="header-pop advanced-search-dialog"
                    id="header-pop"
                    header="ADVANCED SEARCH"
                    visible={advansearch}
                    onHide={closeModal}
                  >
                    <div>
                      <Row>
                        <Col xl={12} className="bg-form advan-modal pe-0">
                          <Card className="popoup-clr bg-form">
                            <CardBody>
                              <Row>
                                <Col xl={12}>
                                  <div>
                                    <Row>
                                      <Col xl={12}>
                                        <Row className="mt-2 align-items-center">
                                          <Col xl={12}>
                                            <label
                                              htmlFor="integer"
                                              className="block mb-2"
                                            >
                                              Keyword Search In{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <Dropdown
                                              value={popAdvance}
                                              onChange={handlePopAdvanceChange}
                                              options={searchpopup}
                                              optionLabel="name"
                                              placeholder="Search In"
                                              className="w-full search-option"
                                            />
                                            {errors.popAdvance && (
                                              <small className="p-error block mt-1">
                                                {errors.popAdvance}
                                              </small>
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className="mt-3 align-items-center">
                                          <Col xl={12}>
                                            <label
                                              htmlFor="integer"
                                              className="block mb-2"
                                            >
                                              Search In
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <InputText
                                              id="integer"
                                              className="w-full"
                                              placeholder="Contains"
                                              value={inputContains}
                                              onChange={handleInputContains}
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mt-2 align-items-center">
                                          <Col xl={12}>
                                            <InputText
                                              id="integer"
                                              className="w-full"
                                              placeholder="Excluded"
                                              value={excludedSearch}
                                              onChange={e =>
                                                setExcludedSearch(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mt-2 align-items-center">
                                          <Col xl={12}>
                                            <InputText
                                              id="integer"
                                              className="w-full"
                                              placeholder="Exact"
                                              value={exactSearch}
                                              onChange={e =>
                                                setExactSearch(e.target.value)
                                              }
                                            />
                                            {!inputContains &&
                                              !excludedSearch &&
                                              !exactSearch && (
                                                <small className="p-error block mt-1">
                                                  Please enter at least one
                                                  search field
                                                </small>
                                              )}
                                          </Col>
                                        </Row>
                                        {/* <Col xl={12} className="bg-form mt-4">
                                          <Card className="popoup-clr bg-form">
                                            <CardBody className="pt-0">
                                              <Row className="advance-sr2">
                                                <Col xs={12}>
                                                  <div className="d-flex">
                                                    <h4 className="mb-0">ADDITIONAL SEARCH CRITERIA</h4>
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xl={12}>
                                                  <div className="add-selectoption">
                                                    <Row>
                                                      <Col xl={12}>
                                                        <div>
                                                          {fields.map((field) => (
                                                            <div key={field.id} className="p-field p-grid p-align-center p-mb-2 mt-2">
                                                              <button
                                                                type="button"
                                                                onClick={() => handleRemoveField(field.id)}
                                                                className="select-close"
                                                              >
                                                                <i className="fa-solid fa-xmark"></i>
                                                              </button>
                                                              <Dropdown
                                                                value={field.value}
                                                                options={dropdownOptions}
                                                                onChange={(e) => handleFieldChange(field.id, e.value)}
                                                                placeholder="Select a Field"
                                                                className="p-mr-2"
                                                                style={{ width: "200px" }}
                                                              />
                                                            </div>
                                                          ))}
                                                          <button
                                                            type="button"
                                                            onClick={handleAddField}
                                                            className="btn btn-secondary import-res-btn mainbtn me-1 mt-3 addfield-pop"
                                                          >
                                                            <i className="fa-regular fa-add me-1"></i> Add a Field to Search
                                                          </button>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </CardBody>
                                          </Card>
                                        </Col> */}
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      type="button"
                                      className="btn btn-secondary import-res-btn mainbtn me-1 mt-3 addfield-pop"
                                      onClick={handleSearchSelect}
                                    >
                                      <i className="pi pi-search"></i> Search
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary import-res-btn mainbtn me-1 mt-3 addfield-pop"
                                      onClick={closeModal}
                                    >
                                      <i className="pi pi-times"></i> Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary import-res-btn mainbtn me-1 mt-3 addfield-pop"
                                      onClick={handleResetAdvancepop}
                                    >
                                      <i className="pi pi-ban"></i> Clear
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Dialog>
                </div>
              </div>
            </div>
            <AddMenu />
          </div>

          <div className="d-flex align-items-center">
            {/* Profile Name and Menu */}

            <div
              className="ProfileNameInATS"
              style={{ fontSize: "15px", fontWeight: "700" }}
            >
              {profileData?.first_name} {profileData?.middle_name}{" "}
              {profileData?.last_name}
            </div>
            <ProfileMenu />

            {/* Notification Bell Icon (Moved outside the parent div) */}
            <div className="NotificationsBar">
              <button
                type="button"
                className="btn notification-bell-button notification-general-button"
                onClick={e => {
                  e.stopPropagation()
                  e.preventDefault()
                  handleNotificationShow()
                }}
                style={{ width: 38, height: 38, padding: 0, margin: 0, display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <FaBell className="notification-bell-icon notification-general-icon" />
                  <span className="badge notification-bell-badge notification-general-badge">
                    {readNotificationCount}
                  </span>
                </div>
              </button>
            </div>

            <div className="position-relative d-flex align-items-center" style={{ order: -1, height: 38, marginRight: 8, flexShrink: 0 }}>
              <button
                type="button"
                className="btn position-relative notification-bell-button notification-document-button"
                aria-label="Candidate document alerts"
                title="Candidate document alerts"
                onClick={openDocumentAlerts}
                style={{ width: 38, height: 38, padding: 0, margin: 0, display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}
              >
                <FaBell className="notification-bell-icon notification-document-icon" />
                {documentAlerts.length > 0 && (
                  <span
                    className="badge rounded-pill bg-danger position-absolute notification-bell-badge notification-document-badge"
                    style={{ fontSize: 10 }}
                  >
                    {documentAlerts.length > 99 ? "99+" : documentAlerts.length}
                  </span>
                )}
              </button>

              {documentAlertOpen && (
                <div
                  className="position-absolute bg-white border shadow-sm"
                  style={{ right: 0, top: "calc(100% + 8px)", width: 440, maxWidth: "min(440px, 90vw)", zIndex: 1060, background: "#fff", border: "1px solid #d9e2ec", borderRadius: 10, boxShadow: "0 12px 30px rgba(15, 23, 42, 0.18)", overflow: "hidden" }}
                  role="dialog"
                  aria-label="Candidate document alerts"
                >
                  <div className="d-flex justify-content-between align-items-center border-bottom px-3 py-2">
                    <strong>Candidate Documents</strong>
                    <button
                      type="button"
                      onClick={() => setDocumentAlertOpen(false)}
                      aria-label="Close document alerts"
                      title="Close"
                      style={{ width: 28, height: 28, padding: 0, border: "1px solid #cbd5e1", borderRadius: "50%", background: "#fff", color: "#334155", display: "inline-flex", alignItems: "center", justifyContent: "center", textAlign: "center", fontFamily: "Arial, sans-serif", fontSize: 18, fontWeight: 400, lineHeight: 1, cursor: "pointer" }}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div style={{ maxHeight: 440, overflowY: "auto" }}>
                    {documentAlertLoading && (
                      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 150 }} aria-label="Loading document alerts">
                        <span className="spinner-border text-danger" role="status" aria-hidden="true" />
                      </div>
                    )}
                    {!documentAlertLoading && documentAlertError && <div className="p-3 text-danger">{documentAlertError}</div>}
                    {!documentAlertLoading && !documentAlertError && !documentAlerts.length && (
                      <div className="p-3 text-muted">All candidate documents are uploaded</div>
                    )}
                    {!documentAlertLoading && !documentAlertError && documentAlerts.map(candidate => {
                      const isPartial = candidate.uploadedNames.length > 0
                      const statusLabel = isPartial ? "Partially uploaded" : "Missing"
                      const statusClass = isPartial ? "text-warning" : "text-danger"
                      const initials = String(candidate.employeeName || "UC").trim().split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join("").toUpperCase()
                      return (
                        <div key={candidate.jobCandidateId || candidate.id} className="border-bottom px-3 py-3" style={{ lineHeight: 1.35 }}>
                          <div className="d-flex justify-content-between align-items-start gap-2">
                            <div className="d-flex align-items-start gap-2 min-w-0">
                              <span aria-hidden="true" style={{ width: 32, height: 32, flex: "0 0 32px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#e8f1fb", color: "#1a5fa8", fontSize: 12, fontWeight: 700 }}>{initials}</span>
                              <div className="min-w-0">
                                <strong className="d-block text-truncate">{candidate.employeeName || "Unnamed candidate"}</strong>
                                <span className="small text-muted text-break">{candidate.personalEmail || "No email"}</span>
                              </div>
                            </div>
                            <span className={`small fw-semibold text-nowrap ${statusClass}`}>{statusLabel}</span>
                          </div>
                          {candidate.jobTitle && candidate.jobTitle !== "-" && <div className="small mt-2 text-truncate" title={candidate.jobTitle}><strong>Job:</strong> {candidate.jobTitle}</div>}
                          <div className="d-flex gap-2 mt-2">
                            <span className="badge bg-light text-dark border">Required {candidate.requiredCount}</span>
                            <span className="badge bg-success-subtle text-success border border-success-subtle">Uploaded {candidate.uploadedCount}</span>
                            <span className="badge bg-danger-subtle text-danger border border-danger-subtle">Pending {candidate.pendingCount}</span>
                          </div>
                          <div className="small mt-2"><strong>Missing documents</strong></div>
                          <div className="d-flex flex-wrap gap-1 mt-1">
                            {candidate.missingNames.length ? candidate.missingNames.map(name => <span key={name} className="text-wrap text-start" style={{ flex: "1 1 180px", padding: "5px 7px", borderRadius: 4, background: "#fff4f4", border: "1px solid #f1c8c8", color: "#b42318", fontSize: 11, lineHeight: 1.25 }}>! {name}</span>) : <span className="small text-muted">None</span>}
                          </div>
                          {candidate.uploadedNames.length > 0 && <>
                            <div className="small mt-2"><strong>Uploaded documents</strong></div>
                            <div className="d-flex flex-wrap gap-1 mt-1">
                              {candidate.uploadedNames.map(name => <span key={name} className="text-wrap text-start" style={{ flex: "1 1 180px", padding: "5px 7px", borderRadius: 4, background: "#f1faf5", border: "1px solid #b9dfc7", color: "#18794e", fontSize: 11, lineHeight: 1.25 }}>✓ {name}</span>)}
                            </div>
                          </>}
                          {candidate.dueDetails.length > 0 && <div className="mt-2">
                            <div className="small"><strong>Due dates</strong></div>
                            <div className="mt-1" style={{ display: "grid", gap: 3 }}>
                              {candidate.dueDetails.map(item => (
                                <div key={`${item.name}-${item.dueDate}`} className="small text-muted d-flex justify-content-between align-items-start gap-2">
                                  <span className="text-break">{item.name}</span>
                                  <span className={item.overdueDays > 0 ? "text-danger text-nowrap fw-semibold" : "text-nowrap"}>
                                    {item.dueDate}{item.overdueDays > 0 ? ` · ${item.overdueDays}d overdue` : ""}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>}
                          <div className="small text-muted mt-2"><strong>Last updated:</strong> {candidate.uploadedAt ? formatUTCDate(candidate.uploadedAt) : "-"}</div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowModal(false)}>
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Notifications</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                {notifications.length > 0 ? (
                  notifications.map((message, index) => (
                    <div
                      key={index}
                      className={`NotificationBlock border-bottom m-1 p-1 d-flex ${message.isRead ? 'read' : ''}`}
                    >
                      <div className="Nofit_Profile">
                        <BsChatLeftText className="Noti_Profile_Img" />
                      </div>
                      <div className="font_13 p-2">
                        <span className="font_weight_700">{message.title}</span>
                        <div className="font_weight_700">{message.message}</div>
                        <div className="Notif_Date font_12 font_weight_500">
                          <div className="d-flex">
                            <span className="font_10 pe-4 pt-1">
                              {new Date(message.createdAt).toLocaleString()}
                            </span>
                            {!message.isRead && (
                              <button
                                className="font_10 border border-none text-primary mt-1"
                                onClick={() => markAsRead(message.id)}
                              >
                                <i className="fa fa-check" aria-hidden="true"></i> Mark as read
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-3">No notifications available.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )} */}

            <Modal
              size="md"
              show={showModal}
              onHide={() => setShowModal(false)}
              className="notification-modal"
              id="All_Notifications_Modal"
              centered
            >
              <Modal.Header closeButton className="notification-header flex-row align-items-between blueBtn m-0">
              <div className="w-100  d-flex justify-content-between align-items-center ">
                <h5 className="modal-title mb-0"><i className="pi pi-bell me-1"></i> Notifications</h5>

                <button
                  className="btn btn-sm  border text-dark"
                  style={{
                    backgroundColor: "#fff",
                    opacity: unreadCount === 0 ? 0.55 : 1,
                    cursor: unreadCount === 0 ? "not-allowed" : "pointer",
                  }}
                  disabled={unreadCount === 0}
                  onClick={handleMarkAllAsRead}
                >
                  ✓ Mark all as read
                </button>
              </div>
            </Modal.Header>
            <Modal.Header className="py-1">
              <div className="notification-tabs w-100 d-flex justify-content-around align-content-center">
                <button
                  className={`tab-btn ${activeTab === "all" ? "active" : ""}`}
                  onClick={() => setActiveTab("all")}
                >
                  <i className="pi pi-list me-1"></i> All ({allCount})
                </button>

                <button
                  className={`tab-btn ${activeTab === "unread" ? "active" : ""}`}
                  onClick={() => setActiveTab("unread")}
                >
                  <i className="pi pi-bell me-1"></i> Unread ({unreadCount})
                </button>

                <button
                  className={`tab-btn ${activeTab === "read" ? "active" : ""}`}
                  onClick={() => setActiveTab("read")}
                >
                  <i className="pi pi-check-circle me-1"></i> Read ({readCount})
                </button>
              </div>
            </Modal.Header>
             <Modal.Body className="notification-body pr-2">
              {tabLoading ? (
                    <div className="text-center py-3">
                      <div
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>):
                (filteredNotifications.length > 0 ? (
                  filteredNotifications.map((notification, index) => (
                    <div
                      key={notification.id}
                      className={`notification-item d-flex ${
                        notification.is_read ? "read" : "unread"
                      }`}
                    >
                      <div className="notification-icon">
                        <i className="pi pi-check-circle"></i>
                      </div>

                      <div className="notification-content">
                        <div className="notification-title">
                          {notification.title || "New Notification"}
                        </div>

                        <div className="notification-message">
                          {notification.message || "No message"}
                        </div>

                        <div className="notification-footer d-flex justify-content-between">
                          <span className="notification-date">
                           {notification.created_at
                              ? formatUTCDate(notification.created_at)
                              : "Just now"}
                          </span>

                          {!notification.is_read && (
                            <button
                              type="button"
                              className="mark-read-btn"
                              onClick={() =>
                                handleMarkAsRead(notification.id, index)
                              }
                            >
                              <i className="fa fa-check me-1"></i> Mark as read
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-notification text-center">
                    No notifications available.
                  </div>
                ))}
              </Modal.Body> 

            </Modal>
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
